/**
 * @file
 * Toggles a `has-value` class on <select> elements so empty/placeholder
 * options can be styled differently from a real selection.
 *
 * Ported from source/default/_patterns/01-atoms/form-element/index.js.
 * Preserved as-is: the original only toggled the class on the `change`
 * event, never on initial load, so a <select> whose default option is
 * already non-empty renders without `has-value` until the user interacts
 * with it. Ported byte-for-byte for behavioral parity; fixing that is a
 * separate decision, not part of this migration.
 */
((Drupal) => {
  function toggleSelectColor(selectElement) {
    if (selectElement.value !== '') {
      selectElement.classList.add('has-value');
    } else {
      selectElement.classList.remove('has-value');
    }
  }

  // eslint-disable-next-line no-param-reassign
  Drupal.behaviors.formElement = {
    attach(context) {
      context.querySelectorAll('select').forEach((selectElement) => {
        if (selectElement.dataset.formElementInitialized) {
          return;
        }
        // eslint-disable-next-line no-param-reassign
        selectElement.dataset.formElementInitialized = 'true';

        selectElement.addEventListener('change', () => {
          toggleSelectColor(selectElement);
        });
      });
    },

    detach(context, settings, trigger) {
      if (trigger === 'unload') {
        context.querySelectorAll('select').forEach((selectElement) => {
          // eslint-disable-next-line no-param-reassign
          delete selectElement.dataset.formElementInitialized;
        });
      }
    },
  };
})(Drupal);
